import type { ChatbotParams } from "@do/shared-types";
import { useEffect } from "react";

// Add stylesheet if theming is set in query params and has a correspondance in chatbotParams
export const useTheming = ({
  chatbotParams,
  theming,
}: {
  chatbotParams: ChatbotParams | null;
  theming?: string;
}) =>
  useEffect(() => {
    if (chatbotParams) {
      if (theming) {
        if (!chatbotParams.stylesheets) {
          // eslint-disable-next-line no-console
          console.warn("No stylesheet in chatbotParams");
          return;
        }
        if (!chatbotParams.stylesheets[theming]) {
          // eslint-disable-next-line no-console
          console.warn(
            `Stylesheet ${theming} not found in chatbotParams. Current stylesheets:`,
            chatbotParams.stylesheets
          );
          return;
        }
      }
      if (!chatbotParams.stylesheets) return;
      const stylesheetContent = theming
        ? chatbotParams.stylesheets[theming]
        : chatbotParams.stylesheets.default;
      if (!stylesheetContent) return;
      const stylesheet = document.createElement("style");
      stylesheet.appendChild(document.createTextNode(stylesheetContent));
      const body = document.querySelector("body");
      body?.appendChild(stylesheet);
    }
  }, [chatbotParams, theming]);
